export default __webpack_public_path__ + "static/media/unstaking-step-three-gamer.724e1172.png";